import { render, staticRenderFns } from "./Change_password.vue?vue&type=template&id=9693db76&scoped=true"
import script from "./Change_password.vue?vue&type=script&lang=js"
export * from "./Change_password.vue?vue&type=script&lang=js"
import style0 from "./Change_password.vue?vue&type=style&index=0&id=9693db76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9693db76",
  null
  
)

export default component.exports